import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import "./style.css";

const BankingServicesBox = () => {
  const history = useHistory();

  const [services, setServices] = useState([
    // {
    //   name: "UTI PAN",
    //   image: "/images/uti-logo.png",
    //   href: "/user/utiitsl_pancard",
    // },
    {
      name: "AEPS",
      image: "/images/aeps-logo.png",
      href: "/user/aeps",
    },
    {
      name: "Micro ATM",
      image: "/images/micro-atm-logo.png",
      href: "/user/micro_atm",
    },
    {
      name: "Settlement",
      image: "/images/settlement-icon.png",
      href: "/user/settlement",
    },
  ]);

  const navigate = (path) => {
    history.push(path);
  };

  return (
    <React.Fragment>
      <div className="dash-serviceBoxTitle">Branchless Banking</div>
      <div className="row pt-2">
        {services.map((value, key) => (
          <div className="col-sm-2">
            <div className="card">
              <div
                className="dash-serviceBox"
                onClick={() => {
                  navigate(value.href);
                }}
              >
                <div className="service-image">
                  <a href>
                    <img
                      className="img-thumbnail rounded-circle avatar-md"
                      alt="logo"
                      src={value.image}
                    />
                  </a>
                </div>
                <div className="service-content">
                  <h6 style={{ color: "black" }}>{value.name}</h6>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

export default BankingServicesBox;
